import { createTransformer, mapToSnakeCase } from './shared/base-api';
import { packageChatStatusResponseSchema, packageChatQueryResponseSchema, } from '../../';
export const chatApiEndpoints = (builder, chatApiBaseUrl) => ({
    getPackagePropChatStatus: builder.query({
        query: ({ projectId, packageId }) => ({
            url: `${chatApiBaseUrl}/projects/${projectId}/packages/${packageId}/status`,
            method: 'GET',
        }),
        transformResponse: createTransformer(packageChatStatusResponseSchema, 'getPackagePropChatStatus'),
    }),
    queryPackagePropChat: builder.query({
        query: ({ projectId, packageId, query }) => ({
            url: `${chatApiBaseUrl}/projects/${projectId}/packages/${packageId}/query`,
            method: 'POST',
            body: mapToSnakeCase(query),
        }),
        transformResponse: createTransformer(packageChatQueryResponseSchema, 'queryPackagePropChat'),
    }),
});
